let store = [{
    province: '北京',
    city: '北京',
    area: '西城区',
    address: '北京市西城区西直门南大街2号成铭大厦D座4层',
    name: '爱康国宾北京西直门分院VIP部',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
},{
    province: '北京',
    city: '北京',
    area: '西城区',
    address: '北京市西城区宣武门外大街32号富卓商厦3A(4层)',
    name: '爱康国宾北京宣武门富卓大厦分院',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
},{
    province: '北京',
    city: '北京',
    area: '西城区',
    address: '北京市西城区宣武门外大街32号富卓商厦3A(4层)',
    name: '爱康国宾北京宣武门富卓大厦分院VIP部',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '北京',
    city: '北京',
    area: '朝阳区',
    address: '北京市朝阳区安立路西侧慧忠北里京师科技大厦第3层',
    name: '爱康卓悦北京亚运村慧忠北里分院',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '北京',
    city: '北京',
    area: '朝阳区',
    address: '北京市朝阳区阜荣街10号首开广场3层',
    name: '爱康国宾北京望之京首开广场分院VIP部（原北京丽都酒仙桥分院）',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
},{
    province: '北京',
    city: '北京',
    area: '朝阳区',
    address: '北京市朝阳区建国门外大街17号1幢1层01-05、7幢1层',
    name: '爱康国宾北京建国门外友谊商店分院VIP部',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
},{
    province: '北京',
    city: '北京',
    area: '朝阳区',
    address: '北京市朝阳区建国门外大街17号1幢1层01-05、7幢1层',
    name: '爱康国宾北京建国门外友谊商店分院',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '北京',
    city: '北京',
    area: '西城区',
    address: '北京市西城区阜成门外大街2号万通金融中心3层',
    name: '爱康卓悦北京阜成门万通大厦分院',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, 
// {
//     province: '北京',
//     city: '北京',
//     area: '朝阳区',
//     address: '北京朝阳区南十里居28号东润枫景',
//     name: '爱康国宾北京酒仙桥分院',
//     word: 'B',
//     url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
//     time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
// }, 
{
    province: '北京',
    city: '北京',
    area: '朝阳区',
    address: '北京市朝阳区朝阳公园南路21号郡王府。朝阳公园桥西北角（郡王府体育中心）',
    name: '爱康国宾北京郡王府分院',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '暂停营业'
},  {
    province: '北京',
    city: '北京',
    area: '朝阳区',
    address: '北京市朝阳区安立路西侧慧忠京师科技大厦2层',
    name: '爱康国宾北京亚运村慧忠北里分院',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '北京',
    city: '北京',
    area: '朝阳区',
    address: '北京市朝阳区安立路西侧慧忠京师科技大厦2层',
    name: '爱康国宾北京亚运村慧忠北里分院VIP部',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '北京',
    city: '北京',
    area: '朝阳区',
    address: '北京市朝阳区工人体育场北路甲2号B栋等3幢裙房1层110-2单元及2层204、205、208、231、232、235、236',
    name: '爱康国宾北京三里屯盈科中心分院',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '北京',
    city: '北京',
    area: '海淀区',
    address: '北京市海淀区北四环西路52号方正国际大厦2层',
    name: '爱康国宾北京中关村方正国际大厦分院',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '北京',
    city: '北京',
    area: '朝阳区',
    address: '北京市朝阳区阜荣街10号首开广场3层',
    name: '爱康国宾北京望之京首开广场分院（原北京丽都酒仙桥分院）',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '北京',
    city: '北京',
    area: '海淀区',
    address: '北京市海淀区西三旗沁春家园1、2、3号楼底商3层301-3022号',
    name: '爱康卓悦北京西三旗悦秀路沁春家园分院',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
}, {
    province: '北京',
    city: '北京',
    area: '海淀区',
    address: '北京市海淀区北四环西路52号方正国际大厦3层',
    name: '爱康卓悦北京中关村方正国际大厦分院',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '北京',
    city: '北京',
    area: '海淀区',
    address: '北京市海淀区羊坊店路21号3层301',
    name: '爱康国宾北京西站瑞海大厦分院',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '北京',
    city: '北京',
    area: '海淀区',
    address: '北京市海淀区羊坊店路21号3层301',
    name: '爱康国宾北京西站瑞海大厦分院VIP部',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '北京',
    city: '北京',
    area: '海淀区',
    address: '北京市海淀区西三环北路100号光耀东方中心四层',
    name: '爱康国宾北京航天桥光耀东方分院',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '北京',
    city: '北京',
    area: '海淀区',
    address: '北京市海淀区西三环北路100号光耀东方中心四层',
    name: '康国宾北京航天桥光耀东方分院VIP部',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '北京',
    city: '北京',
    area: '顺义区',
    address: '北京市顺义区顺平路南法信镇顺捷大厦A座二层203室',
    name: '爱康国宾北京顺平分院',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
}, {
    province: '北京',
    city: '北京',
    area: '丰台区',
    address: '北京市丰台区南四环西路188号1区31号楼',
    name: '爱康国宾北京总部基地分院',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
}, {
    province: '北京',
    city: '北京',
    area: '丰台区',
    address: '北京市丰台区南四环西路188号一区31号楼A座旁一层（厦门国际银行旁边）',
    name: '爱康国宾北京总部基地分院VIP部',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
}, {
    province: '北京',
    city: '北京',
    area: '东城区',
    address: '北京市东城区珠市口东大街6号珍贝大厦2层',
    name: '爱康国宾北京磁器口分院',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '北京',
    city: '北京',
    area: '东城区',
    address: '北京市东城区珠市口东大街6号珍贝大厦2层',
    name: '爱康国宾北京磁器口分院VIP部',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '北京',
    city: '北京',
    area: '顺义区',
    address: '北京市顺义区顺平路南法信段9号，顺捷大厦二层203，（汽配城斜对面、镇政府附近）',
    name: '爱康国宾北京顺平分院VIP部',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
},  {
    province: '北京',
    city: '北京',
    area: '通州区',
    address: '北京市通州区惠济东路3号院2号楼2层201、202',
    name: '爱康卓悦北京通州北关新光大通新分院',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '北京',
    city: '北京',
    area: '通州区',
    address: '北京市通州区惠济东路3号院2号楼2层201、202',
    name: '爱康国宾北京通州北关新光大通新分院',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
},

 {
    province: '安徽',
    city: '合肥',
    area: '高新区',
    address: '合肥市高新区长江西路689号拓基城市广场金座C，从8号9号电梯上二楼',
    name: '爱康卓悦合肥高新拓基中心分院',
    word: 'H',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '安徽',
    city: '合肥',
    area: '蜀山区',
    address: '合肥市蜀山区东流路西999号新际商务中心C幢508',
    name: '爱康国宾合肥天鹅湖东路新城国际分院',
    word: 'H',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '安徽',
    city: '滁州',
    area: '',
    address: '滁州市苏滁开发区寿昌路苏滁医院医技楼二楼',
    name: '安徽苏滁健康体检中心',
    word: 'C',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
},{
    province: '安徽',
    city: '蚌埠',
    area: '龙子湖区',
    address: '安徽省蚌埠市龙子湖区治淮路58号',
    name: '蚌埠美华健康',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
},{
    province: '安徽',
    city: '安庆',
    area: '迎江区',
    address: '安庆市迎江区皖江大道77号紫峰大厦B座4-7层',
    name: '安庆市爱康健康管理有限公司',
    word: 'A',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, {
    province: '安徽',
    city: '马鞍山',
    area: '',
    address: '花山区湖北路4-2号',
    name: '马鞍山和协医院',
    word: 'M',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周六：07：30-9:00（法定假日放假）'
}, {
    province: '安徽',
    city: '六安',
    area: '',
    address: '徽省六安市郝岗路与晋善路交口',
    name: '六安康宁健康体检',
    word: 'L',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周二至周日：7:30-11:30（法定假日放假）'
}, {
    province: '福建',
    city: '福州',
    area: '鼓楼区',
    address: '福州市六一北路328号金源花园三层',
    name: '爱康国宾福州鼓楼分院',
    word: 'F',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '福建',
    city: '福州',
    area: '鼓楼区',
    address: '福州市六一北路328号金源花园三层',
    name: '爱康国宾福州鼓楼分院VIP部',
    word: 'F',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '福建',
    city: '福州',
    area: '台江区',
    address: '福建省福州市台江区鳌峰街道曙光路132号申发大厦3层01-07单元',
    name: '爱康卓悦福州金融街申发大厦分院',
    word: 'F',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}
    // ,{
    //     province:'福建',
    //     city:'漳州',
    //     area:'芗城区',
    //     address:'福建省漳州市胜利西路59号',
    //     name:'漳州市医院',
    //     word:'Z',
    //     url:'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    //     time:'放假时间：1月24日-2月13日'
    // }
    //     , {
    //     province: '福建',
    //     city: '漳州',
    //     area: '芗城区',
    //     address: '福建省漳州市北环城路1608号（正兴学校旁）',
    //     name: '漳州正兴医院',
    //     word: 'Z',
    //     url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    //     time: '营业时间：周一至周六：7:30-11:30（法定假日放假）'
    // }
    , {
    province: '福建',
    city: '漳州',
    area: '芗城区',
    address: '福建省漳州市龙文区迎宾路5号C幢二楼',
    name: '漳州市第三医院',
    word: 'Z',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：7:30-11:30（法定假日放假）'
}, {
    province: '福建',
    city: '漳州',
    area: '龙文区',
    address: '福建省漳州市龙文区迎宾大道5号立交桥人民广场东侧',
    name: '漳州市第三医院',
    word: 'Z',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：8:00-12:00（法定假日放假）'
}
    // ,{
    //     province:'福建',
    //     city:'泉州',
    //     area:'丰泽区',
    //     address:'福建省泉州市丰泽区东海丰海路西段(延年山庄内)',
    //     name:'泉州延年健康管理中心',
    //     word:'Q',
    //     url:'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    //     time:'放假时间：1月24日-2月13日'
    // }
    , {
    province: '福建',
    city: '泉州',
    area: '鲤城区',
    address: '福建省泉州市鲤城区少林路315号科技中学基金楼（盛世领墅旁）',
    name: '美亚健康体检泉州鲤城分院',
    word: 'Q',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周二至周六：7:30-11:30（法定假日放假）'
},{
    province: '福建',
    city: '宁德市',
    area: '',
    address: '福建省福鼎市玉龙北路310号鼎融公馆3栋',
    name: '美亚健康体检福鼎分院',
    word: 'N',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
},{
    province: '福建',
    city: '龙岩市',
    area: '新罗区',
    address: '福建省龙岩市新罗区西城西沣路19号龙岩市博爱医院1号楼二楼体检中心',
    name: '龙岩市博爱医院',
    word: 'L',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
},{
    province: '福建',
    city: '三明市',
    area: '新罗区',
    address: '福建省三明市三元区东新二路9号12层',
    name: '三明美亚',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
},   {
    province: '福建',
    city: '厦门',
    area: '湖里区',
    address: '厦门市湖里区五缘湾眼科医院园区内四号楼三楼',
    name: '厦门湖里高尚门诊部',
    word: 'X',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周六：8：00-10：30（法定假日休息）'
}, {
    province: '福建',
    city: '衢州',
    area: '柯城区',
    address: '浙江省衢州市柯城区双港路176号',
    name: '柯城人民医院体检中心',
    word: 'H',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, {
    province: '广东',
    city: '东莞',
    area: '松山湖区',
    address: '东莞市松山湖高新技术开发区科技二路5号中国电子产业园3号楼201',
    name: '爱康卓悦东莞松山湖中国电子产业园分院',
    word: 'D',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '广东',
    city: '东莞',
    area: '南城区',
    address: '东莞市南城区元美路2号财富广场2楼',
    name: '爱康国宾东莞南城财富广场分院',
    word: 'N',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '广东',
    city: '佛山',
    area: '南海区',
    address: '佛山市南海区桂城灯湖东路1号友邦金融中心一座25层',
    name: '爱康卓悦佛山千灯湖分院',
    word: 'F',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
}, {
    province: '广东',
    city: '佛山',
    area: '禅城区',
    address: '广东省佛山市禅城区季华四路115号B座宏宇国金大厦二层',
    name: '爱康国宾佛山禅城分院',
    word: 'F',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '广东',
    city: '佛山',
    area: '禅城区',
    address: '广东省佛山市禅城区季华四路115号B座二层',
    name: '爱康国宾佛山禅城分院VIP部',
    word: 'F',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '广东',
    city: '佛山',
    area: '顺德区',
    address: '广东省佛山市顺德区国泰南路3号保利商贸中心一号楼3楼',
    name: '爱康国宾佛山顺德保利商贸中心分院',
    word: 'F',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '广东',
    city: '广州',
    area: '越秀区',
    address: '广州市越秀区环市东路496号广发花园大厦2层（国宾健康检查中心）',
    name: '爱康国宾广州环市东分院2层',
    word: 'G',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
}, {
    province: '广东',
    city: '广州',
    area: '越秀区',
    address: '广州市越秀区环市东路496号广发花园4层(动物园南门站)',
    name: '爱康国宾广州环市东分院四层VIP部',
    word: 'G',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周三至周日：08：00-10:30（法定假日放假）'
},  {
    province: '广东',
    city: '广州',
    area: '越秀区',
    address: '广州市越秀区环市东路496号广发花园大厦3层（国宾健康检查中心）',
    name: '爱康国宾广州环市东分院3层',
    word: 'G',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
}, {
    province: '广东',
    city: '广州',
    area: '越秀区',
    address: '广州市越秀区环市东路496号广发花园大厦4层（国宾健康检查中心）',
    name: '爱康国宾广州环市东分院4层',
    word: 'G',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
}, {
    province: '广东',
    city: '广州',
    area: '天河区',
    address: '广州市天河区林和西路中泰国际广场商场5层',
    name: '爱康国宾广州林和西中泰分院',
    word: 'G',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周日至周五：08：00-10:30（法定假日放假）'
}, {
    province: '广东',
    city: '广州',
    area: '天河区',
    address: '广州市天河区中山大道东方一路20-24号华港花园3层（BRT华景新城站）',
    name: '爱康国宾广州天河华港花园分院',
    word: 'G',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周日至周五：08：00-10:30（法定假日放假）'
}, {
    province: '广东',
    city: '广州',
    area: '天河区',
    address: '广州市天河区珠江新城花城大道7号南天广场商务中心3-5层（南天珠宝世界）',
    name: '爱康国宾广州花城大道南天广场分院3-五层',
    word: 'G',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
}, {
    province: '广东',
    city: '广州',
    area: '海珠区',
    address: '广州市海珠区暄悦东街23号保利中悦广场写字楼（南塔）裙楼3楼（地铁站：万胜围D出口）',
    name: '爱康卓悦广州琶洲保利中悦分院',
    word: 'G',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
}, {
    province: '广东',
    city: '深圳',
    area: '福田区',
    address: '深圳市福田区滨河路北彩田路东交汇处联合广场裙楼B座201、203',
    name: '爱康国宾深圳福田分院',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '广东',
    city: '深圳',
    area: '福田区',
    address: '深圳市福田区滨河路北彩田路东交汇处联合广场A座裙楼3022',
    name: '爱康国宾深圳福田分院（三层VIP部）',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周四至周二：08：00-10:30（法定假日放假）'
},{
    province: '广东',
    city: '深圳',
    area: '福田区',
    address: '深圳市福田区深南大道6031号杭钢富春商务大厦1层、2层',
    name: '爱康卓悦深圳车公庙杭钢富春大厦分院',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '广东',
    city: '深圳',
    area: '南山区',
    address: '深圳市南山区高新科技园中区科苑路科兴科学园东门B座3单元3A层（荣粤酒家正门左侧电梯上）',
    name: '爱康国宾深圳科技园科兴分院',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '广东',
    city: '深圳',
    area: '宝安区',
    address: '深圳市宝安区西乡街道永丰社区新湖路4008号蘅芳科技大厦3楼',
    name: '爱康国宾深圳宝安蘅芳科技大厦分院',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '广东',
    city: '深圳',
    area: '南山区',
    address: '深圳市南山区高新科技园中区科苑北路科兴科学园B座3单元3A层(4楼)',
    name: '爱康国宾深圳科技园科兴分院VIP部',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '广东',
    city: '深圳',
    area: '宝安区',
    address: '深圳市宝安区西乡街道永丰社区新湖路4008号蘅芳科技大厦3楼-3层',
    name: '爱康国宾深圳宝安蘅芳科技大厦分院VIP部',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '广东',
    city: '深圳',
    area: '南山区',
    address: '深圳市南山区东滨路汇滨广场二期裙楼1-3层',
    name: '爱康卓悦深圳快验保分院',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '广东',
    city: '深圳',
    area: '罗湖区',
    address: '深圳市罗湖区宝安南路3044号天地大厦1层3层',
    name: '爱康国宾深圳罗湖分院',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '广东',
    city: '深圳',
    area: '罗湖区',
    address: '深圳市罗湖区宝安南路3044号天地大厦1、3层',
    name: '爱康国宾深圳罗湖分院VIP部',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '广东',
    city: '惠州',
    area: '惠城区',
    address: '惠州市惠城区惠州大道11号佳兆业中心二期(C座酒店、写字楼)7层01号',
    name: '爱康卓悦惠州江北佳兆业广场分院',
    word: 'H',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：4月4日-5日放假，4月6日营业'
},  {
    province: '广东',
    city: '珠海',
    area: '前山工业区',
    address: '珠海市前山工业区华宇路619号',
    name: '珠海禅诚医院',
    word: 'Z',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周日：7:30-11:30（法定假日放假）'
}, {
    province: '广东',
    city: '中山市',
    area: '西区',
    address: '中山市西区康欣路3号中医院住院部2层',
    name: '中山市中医院体检中心',
    word: 'Z',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：8:00-12:00（法定假日放假）'
}, {
    province: '广东',
    city: '肇庆',
    area: '端州区',
    address: '广东省肇庆市端州区端州六路20号',
    name: '肇庆市中医医院体检中心',
    word: 'Z',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：8:00-12:00（法定假日放假）'
}, {
    province: '广东',
    city: '江门',
    area: '蓬江区',
    address: '江门市蓬江区蓬莱路高第里172号',
    name: '江门市人民医院',
    word: 'J',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：8:00-12:00（法定假日放假）'
},  {
    province: '广东',
    city: '湛江',
    area: '',
    address: '湛江市霞山人民大道南57号',
    name: '广东医科大学附属医院',
    word: 'Z',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：8:00-12:00（法定假日放假）'
},{
    province: '广东',
    city: '阳江',
    area: '江城区',
    address: '阳江市江城区东山路42号',
    name: '阳江市人民医院',
    word: 'Y',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
},{
    province: '广东',
    city: '茂名',
    area: '',
    address: '茂名市幸福路滨河一街7号',
    name: '茂名石化医院体检中心',
    word: 'M',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
},{
    province: '广东',
    city: '汕头',
    area: '',
    address: '广东省汕头市龙湖区长平路华银国际大厦3楼',
    name: '第一健康汕头医疗管理中心',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, {
    province: '贵州',
    city: '毕节',
    area: '七星关区',
    address: '毕节市七星关区市西街道松山路95号三江花园B栋2层',
    name: '爱康国宾毕节松山路三江花园分院',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
},  {
    province: '贵州',
    city: '贵阳',
    area: '云岩区',
    address: '贵州省贵阳市云岩区中山西路16号恒峰步行街写字楼A、B层',
    name: '爱康国宾贵阳市云岩恒峰分院',
    word: 'G',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '贵州',
    city: '贵阳',
    area: '云岩区',
    address: '贵州省贵阳市云岩区未来方舟D5组团二期5栋(燕隼公园旁) ',
    name: '爱康卓悦贵阳北京东路未来方舟D5组团分院',
    word: 'G',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '贵州',
    city: '贵阳',
    area: '观山湖区',
    address: '贵州省贵阳市观山湖区龙泉苑街9号独栋商业楼',
    name: '贵州爱康国宾体检中心韦顺达源移动分院',
    word: 'G',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '放假时间：1月30日-2月15日'
}, {
    province: '贵州',
    city: '六盘水',
    area: '钟山区',
    address: '贵州省六盘水市钟山区钟山路59号（雨田广场五层）A栋501.B栋502.503',
    name: '爱康国宾贵州六盘水国贸分院',
    word: 'L',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
},  {
    province: '贵州',
    city: '兴义',
    area: '兴义市',
    address: '贵州省黔西南州兴义市桔山办金州体育城B5印象兴义地块13号楼',
    name: '爱康国宾兴义印象兴义分院',
    word: 'X',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
}, {
    province: '贵州',
    city: '遵义',
    area: '红花岗区',
    address: '贵州省遵义市红花岗区银河西路公交综保基地2号楼地上1-6层',
    name: '爱康国宾遵义银河路分院',
    word: 'Z',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
}
    // ,{
    //     province:'海南',
    //     city:'海口',
    //     area:'美兰区',
    //     address:'海南省海口市美兰区蓝天街道国瑞写字楼S5项目B座三-四层',
    //     name:'海口爱康卓悦体检中心',
    //     word:'H',
    //     url:'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    //     time:'放假时间：1月24日-2月15日'
    // }
    , {
    province: '海南',
    city: '海口',
    area: '美兰区',
    address: '海南省海口市美兰区蓝天街道国兴大道国瑞大厦B座西塔3-4楼',
    name: '爱康卓悦海口国兴大道国瑞大厦分院',
    word: 'H',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
}, {
    province: '河北',
    city: '石家庄',
    area: '桥西区',
    address: '石家庄市桥西区裕华路66号海悦天地A座七层',
    name: '爱康卓悦石家庄裕华路海悦天地分院',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '河北',
    city: '邯郸',
    area: '丛台区',
    address: '邯郸市人民东路与秦皇大街交叉口东北角锦河湾小区',
    name: '邯郸仁泰体检中心',
    word: 'H',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：7:30-11:00（法定假日放假）'
}, {
    province: '河北',
    city: '保定',
    area: '新市区',
    address: '保定市竞秀区创业路299号福道慈惠医院(轩宇和安检测线对面)',
    name: '保定慈惠健康体检中心',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周六：7:30-11:30（法定假日放假）'
}, {
    province: '河北',
    city: '唐山',
    area: '路南区',
    address: '河北省唐山市路南区南湖美食广场3-701楼',
    name: '唐山新华健康体检中心',
    word: 'T',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：8:00-12:00（法定假日放假）'
}, {
    province: '河北',
    city: '沧州',
    area: '运河区',
    address: '沧州市运河区华西新区C区综合楼',
    name: '沧州慈惠体检中心',
    word: 'C',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：7:30-11:00（法定假日放假）'
}, {
    province: '河北',
    city: '廊坊',
    area: '',
    address: '廊坊市建设北路316号（建设路与北凤道交口西北角）',
    name: '廊坊红十字体检中心',
    word: 'L',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, {
    province: '河北',
    city: '张家口',
    area: '桥东区',
    address: '张家口市桥东区工业东街19号（红旗楼高架桥下原康美会馆）',
    name: '张家口健康树健康体检中心',
    word: 'L',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周六：7:30-11:30（法定假日放假）'
}, {
    province: '河北',
    city: '承德',
    area: '桥东区',
    address: '承德市双桥区迎宾路12号嘉禾广场C座',
    name: '承德慈惠',
    word: 'C',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, {
    province: '河北',
    city: '保定市',
    area: '',
    address: '保定市雄县温泉小镇商业街B座16号',
    name: '雄县国宾普惠体检中心',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, {
    province: '河南',
    city: '郑州',
    area: '金水区',
    address: '河南省郑州市金水区金水东路16号万鼎广场4层',
    name: '爱康卓悦郑州金水东路万鼎广场分院',
    word: 'Z',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '河南',
    city: '郑州',
    area: '中原区',
    address: '郑州市中原区中原中路82号中企发展大厦5层',
    name: '爱康国宾郑州中原中路中企大厦分院',
    word: 'Z',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
},{
    province: '河南',
    city: '信阳',
    area: '平桥区',
    address: '河南省信阳市平桥区南京路54号',
    name: '信阳市肿瘤医院',
    word: 'X',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, {
    province: '河南',
    city: '洛阳',
    area: '洛龙区',
    address: '南省洛阳市洛龙区王城大道与英才路交叉口1号西南角佰康体检',
    name: '洛阳佰康体检中心',
    word: 'L',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-11:30（法定假日放假）'
}, {
    province: '河南',
    city: '焦作',
    area: '解放区',
    address: '河南省焦作市解放区人民路与政二街交叉口四季新大厦四楼',
    name: '焦作华健医疗健康体检中心有限公司',
    word: 'J',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周日：07:30-11:00（法定假日放假）'
}, {
    province: '河南',
    city: '南阳',
    area: '解放区',
    address: '河南省南阳市宛城区工农路312号',
    name: '南阳市中心医院体检中心',
    word: 'N',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, {
    province: '河南',
    city: '平顶山',
    area: '',
    address: '河南省平顶山市新华区曙光街49号',
    name: '平顶山第二人民医院',
    word: 'P',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周六：07:30-11:00（法定假日放假）'
}, {
    province: '河南',
    city: '新乡',
    area: '',
    address: '河南省新乡市长垣县博爱路8号',
    name: '新乡宏力医院',
    word: 'X',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周日：07:30-11:30（法定假日放假）'
}, {
    province: '河南',
    city: '商丘',
    area: '睢阳区',
    address: '河南省商丘市睢阳区南京路与归德路交叉口东200米路南',
    name: '商丘艾瑞健康体检',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07：30-16:30（法定假日放假）'
}, {
    province: '湖北',
    city: '武汉',
    area: '东湖新技术开发区',
    address: '武汉市东湖新技术开发区民族大道219号同学广场A区2层001号',
    name: '爱康国宾武汉光谷同学广场分院VIP部',
    word: 'W',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '湖北',
    city: '武汉',
    area: '江汉区',
    address: '武汉市江汉区后襄河二路59号海马中心写字楼商业裙楼三层',
    name: '爱康国宾武汉金墩分院',
    word: 'W',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '湖北',
    city: '武汉',
    area: '江汉区',
    address: '武汉市江汉区后襄河北路59号1幢3层',
    name: '爱康国宾武汉金墩分院VIP部',
    word: 'W',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '湖北',
    city: '武汉',
    area: '武昌区',
    address: '武汉市武昌区武珞路南方帝园3层',
    name: '爱康国宾武汉亚贸分院',
    word: 'W',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
},{
    province: '湖北',
    city: '武汉',
    area: '武昌区',
    address: '武汉市武昌区中北路86号楚河汉街总部国际B座3F',
    name: '爱康国宾武汉汉街总部国际分院',
    word: 'W',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
}, {
    province: '湖北',
    city: '武汉',
    area: '东湖新技术开发区',
    address: '武汉市东湖新技术开发区民族大道219号同学广场A区2层001号',
    name: '爱康国宾武汉光谷同学广场分院',
    word: 'W',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '湖北',
    city: '宜昌',
    area: '西陵区',
    address: '宜昌市西陵区西陵一路51号均瑶酒店7层',
    name: '爱康卓悦宜昌均瑶广场分院',
    word: 'Y',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
}, {
    province: '湖北',
    city: '孝感',
    area: '孝感市',
    address: '孝感市天仙北路26号银泰城14层',
    name: '爱康国宾孝感银泰分院',
    word: 'X',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：视排期情况定'
}, {
    province: '湖北',
    city: '襄阳',
    area: '樊城区',
    address: '湖北省襄阳市樊城区星火路1号(人民广场武商侧门3层)',
    name: '襄阳阳光健康体检中心',
    word: 'X',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周日：7:30-11:00（法定假日放假）'
},{
    province: '湖北',
    city: '黄石',
    area: '黄石港区',
    address: '湖北省黄石市黄石港区青山路102号',
    name: '黄石市第二医院',
    word: 'X',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周六：8:00-11:00（法定假日放假）'
}, {
    province: '湖北',
    city: '鄂州',
    area: '鄂城区',
    address: '鄂州市鄂城区文星路9号',
    name: '鄂州市中心医院',
    word: 'E',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, {
    province: '湖北',
    city: '黄冈',
    area: '',
    address: '黄州区考棚街11号（新区地址：湖滨大道辅路）',
    name: '黄冈市中心医院',
    word: 'H',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, {
    province: '湖北',
    city: '十堰市',
    area: '茅箭区',
    address: '十堰市茅箭区朝阳中路39号',
    name: '十堰市人民医院',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, {
    province: '湖北',
    city: '荆州',
    area: '',
    address: '江汉北路55号6号楼一楼健康管理中心',
    name: '荆州市第一人民医院',
    word: 'J',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, {
    province: '湖南',
    city: '长沙',
    area: '开福区',
    address: '长沙市开福区芙蓉中路一段593号潇湘华天酒店6层',
    name: '爱康国宾长沙八一桥华天酒店分院',
    word: 'C',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '湖南',
    city: '长沙',
    area: '岳麓区',
    address: '长沙市岳麓区枫林三路49号西中心大厦（汽车西站旁）T1写字楼4层',
    name: '爱康国宾长沙河西西中心分院',
    word: 'C',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '湖南',
    city: '长沙',
    area: '雨花区',
    address: '长沙市雨花区湘府东路258号双塔国际广场A座2层',
    name: '爱康国宾长沙湘府东路双塔国际分院',
    word: 'C',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '湖南',
    city: '株洲',
    area: '天元区',
    address: '湖南省株洲市天元区长江北路1号华天大酒店四楼',
    name: '爱康国宾株洲天元华天大酒店分院',
    word: 'Z',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周四：08：00-10:30（法定假日放假）'
}, {
    province: '湖南',
    city: '衡阳',
    area: '雁峰区',
    address: '湖南省衡阳市雁峰区打线坪68号H栋2-3楼',
    name: '衡阳市康宁健康管理有限公司康宁体检门诊部',
    word: 'H',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周六：8:00-11:30（法定假日放假）'
},{
    province: '湖南',
    city: '郴州',
    area: '',
    address: '南院体检中心，住院部4楼，青年大道8号',
    name: '郴州市第一人民医院',
    word: 'Z',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
},{
    province: '湖南',
    city: '湘潭',
    area: '',
    address: '湘潭市和平路120号',
    name: '湘潭市中心医院',
    word: 'X',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
},{
    province: '湖南',
    city: '岳阳市',
    area: '',
    address: '湖南省岳阳市岳阳楼望岳路102号',
    name: '岳阳广济医院',
    word: 'Y',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, {
    province: '吉林',
    city: '长春',
    area: '宽城区',
    address: '长春市宽城区贵阳街287号建设大厦3楼（建设大厦原吉林省政务大厅南门）',
    name: '爱康国宾长春建设分院',
    word: 'C',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '吉林',
    city: '长春',
    area: '南关区',
    address: '长春市南关区亚泰大街6988号（吉林地税南行200米）',
    name: '爱康国宾长春亚泰鸿城西域分院',
    word: 'C',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '暂停营业'
},{
    province: '吉林',
    city: '吉林',
    area: '',
    address: '吉林市长春路9号',
    name: '吉林市中西医结合医院',
    word: 'J',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, {
    province: '江苏',
    city: '江阴',
    area: '江阴市',
    address: '江阴市滨江中路534号嘉年华广场10幢',
    name: '爱康卓悦江阴嘉年华广场分院',
    word: 'J',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
},   {
    province: '江苏',
    city: '南京',
    area: '鼓楼区',
    address: '南京市鼓楼区中央路19号金峰大厦3层',
    name: '爱康国宾南京鼓楼分院',
    word: 'N',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '江苏',
    city: '南京',
    area: '鼓楼区',
    address: '南京市鼓楼区中央路19号金峰大厦3层',
    name: '爱康国宾南京鼓楼分院VIP部',
    word: 'N',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '江苏',
    city: '南京',
    area: '江宁区',
    address: '南京市江宁区双龙大道1118号金轮新都汇2层',
    name: '爱康国宾南京江宁分院',
    word: 'N',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '江苏',
    city: '南京',
    area: '江宁区',
    address: '南京市江宁区双龙大道1118号金轮新都汇广场2层',
    name: '爱康国宾南京江宁分院VIP部',
    word: 'N',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '江苏',
    city: '南京',
    area: '秦淮区',
    address: '南京市秦淮区汉中路1-1号',
    name: '爱康卓悦南京新街口国金旗舰中心分院',
    word: 'N',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '江苏',
    city: '南京',
    area: '浦口区',
    address: '南京市浦口区江浦街道浦口大道1号新城总部大厦305、306、307、308、309、310',
    name: '爱康国宾南京浦口大道新城总部大厦分院',
    word: 'N',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '江苏',
    city: '南京',
    area: '建邺区',
    address: '南京市建邺区庐山路168号新地中心二期西格玛广场2楼C区',
    name: '爱康卓悦南京河西庐山路新地中心分院',
    word: 'N',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '江苏',
    city: '苏州',
    area: '工业园区',
    address: '苏州工业园区东环路1408号东环时代广场商业裙楼1-2层',
    name: '爱康国宾苏州东环分院',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '江苏',
    city: '苏州',
    area: '工业园区',
    address: '苏州市工业园区东环路1408号东环时代广场2楼201',
    name: '爱康国宾苏州东环分院VIP部',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '江苏',
    city: '苏州',
    area: '吴江区',
    address: '苏州市吴江区东太湖生态旅游度假区(太湖新城)风清街199号鑫蹊商务大厦201',
    name: '爱康国宾苏州太湖新城鑫蹊大厦分院',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '江苏',
    city: '苏州',
    area: '吴江区',
    address: '苏州市吴江区东太湖生态旅游度假区(太湖新城)风清街199号鑫蹊商务大厦201',
    name: '爱康国宾苏州太湖新城鑫蹊大厦分院VIP部',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '江苏',
    city: '苏州',
    area: '吴江区',
    address: '苏州市人民路3110号国发大厦2层A-2-10单元、3层A-3-11单元、3层A-3-12单元',
    name: '爱康卓悦苏州姑苏国发大厦旗舰中心',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '江苏',
    city: '苏州',
    area: '高新区',
    address: '苏州高新区运河路77号乐嘉汇商务广场2幢101',
    name: '爱康国宾苏州高新分院',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周三至周一：08：00-10:30（法定假日放假）'
}, {
    province: '江苏',
    city: '苏州',
    area: '高新区',
    address: '苏州市高新区运河路77号乐嘉汇商务广场2-101-201',
    name: '爱康国宾苏州高新分院VIP部',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周三至周一：08：00-10:30（法定假日放假）'
}, {
    province: '江苏',
    city: '泰州',
    area: '海陵区',
    address: '泰州市海陵区电视塔下，凤城国际西大门进入二楼（整层均是）',
    name: '爱康国宾泰州青年南路凤城国际分院',
    word: 'T',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
},  {
    province: '江苏',
    city: '无锡',
    area: '梁溪区',
    address: '无锡市梁溪区人民中路118号',
    name: '爱康卓悦无锡崇安寺金鼎广场分院',
    word: 'W',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '江苏',
    city: '无锡',
    area: '新吴区',
    address: '无锡市新吴区长江路1-101号茂业百货F层',
    name: '爱康国宾无锡新吴茂业分院',
    word: 'W',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '江苏',
    city: '镇江',
    area: '京口区',
    address: '镇江市长江路33号镇江广电大厦裙楼3层',
    name: '爱康国宾镇江长江路文广分院',
    word: 'Z',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '江苏',
    city: '镇江',
    area: '京口区',
    address: '江苏省镇江市京口区长江路33号广电大厦裙楼3层',
    name: '爱康国宾镇江长江路文广分院VIP部',
    word: 'Z',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '江苏',
    city: '常州',
    area: '新北区',
    address: '常州市新北区龙锦路1268号B座座1-3楼',
    name: '爱康卓悦常州龙锦路分院',
    word: 'C',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '江苏',
    city: '南通',
    area: '崇川区',
    address: '南通市崇川区世纪大道18号恒隆国际大厦E座1',
    name: '爱康卓悦南通世纪大道恒隆国际分院',
    word: 'N',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '江苏',
    city: '徐州',
    area: '泉山区',
    address: '江苏省徐州市泉山区西安北路2号瑞银中心1号楼4-5层',
    name: '爱康卓悦徐州西安北路瑞银中心分院',
    word: 'X',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '江苏',
    city: '常州市',
    area: '武进区',
    address: '常州市武进区常武中路63号天禄商务广场3F',
    name: '爱康国宾常州武进天禄广场分院',
    word: 'X',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
},  {
    province: '江苏',
    city: '苏州市',
    area: '工业园区',
    address: '苏州市园区观枫街1号文化艺术中心2楼3-4号馆',
    name: '苏州爱康卓悦（文化艺术中心）',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
},  {
    province: '江苏',
    city: '盐城',
    area: '',
    address: '江苏省盐城市东进路与西环路交叉路口',
    name: '盐城市康华瑞健康管理有限公司综合门诊部',
    word: 'Y',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, {
    province: '江苏',
    city: '淮安市',
    area: '清江浦区',
    address: '江苏省淮安市清江浦区水渡口街道南京路2号',
    name: '淮安和禧康宁医院有限公司',
    word: 'H',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周日：07:30-10:30（法定假日放假）'
}, {
    province: '江苏',
    city: '扬州市',
    area: '邗江区',
    address: '江苏省扬州市邗江区邗江中路158号',
    name: '扬州美天健康管理有限公司',
    word: 'Y',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周五至周三：07:30-10:30（法定假日放假）'
}, 
{
    province: '江西',
    city: '九江',
    area: '浔阳区',
    address: '江西省九江市浔阳区南湖路116号远洲国际商务巷东区二楼',
    name: '九江中鼎体检中心',
    word: 'J',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, 
{
    province: '江西',
    city: '上饶',
    area: '信州区',
    address: '江西省上饶市信州区凤凰东大道188号',
    name: '上饶美康医学健康体检中心',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, {
    province: '江西',
    city: '南昌',
    area: '红谷滩区',
    address: '江西省南昌市红谷滩区秋水广场地铁一号线3号出口对面',
    name: '爱康卓悦南昌秋水广场香格里拉分院',
    word: 'N',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
},
// {
//     province: '江西',
//     city: '南昌',
//     area: '红谷滩新区',
//     address: '江西省南昌市红谷滩新区翠林路669号南昌香格里拉大酒店',
//     name: '爱康卓悦南昌秋水广场香格里拉分院外检',
//     word: 'N',
//     url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
//     time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
// }, 
{
    province: '江西',
    city: '赣州',
    area: '',
    address: '赣州市红旗大道21号(红旗二校旁农业局大院)',
    name: '赣州仁心体检中心',
    word: 'G',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周六：07:30-12:00（法定假日放假）'
},
{
    province: '江西',
    city: '萍乡市',
    area: '安源区',
    address: '江西省萍乡市安源区萍安中大道295号',
    name: '萍乡仁心健康体检中心',
    word: 'P',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
},
{
    province: '辽宁',
    city: '沈阳',
    area: '沈河区',
    address: '沈阳市沈河区青年大街166号',
    name: '爱康国宾沈阳青年大街分院',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
},  {
    province: '辽宁',
    city: '沈阳',
    area: '沈河区',
    address: '沈阳市沈河区青年大街158号',
    name: '爱康国宾沈阳青年大街分院VIP部',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
},  {
    province: '辽宁',
    city: '大连',
    area: '沙河口区',
    address: '大连市沙河口区太原街175-4号新星星海中心B座二层',
    name: '爱康卓悦大连星海广场新星星海分院',
    word: 'D',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周三至周六：08：00-10:30（法定假日放假）'
},  
{
    province: '辽宁',
    city: '葫芦岛',
    area: '龙港区',
    address: '辽宁省葫芦岛市龙港区锦葫路76号',
    name: '葫芦岛市第二人民医院',
    word: 'H',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：7:30-10:30（法定假日放假）'
}, 
{
    province: '辽宁',
    city: '营口市',
    area: '老边区',
    address: '辽宁省营口市老边区盼盼路58号 汤达康体检中心',
    name: '老边谂达康医院',
    word: 'Y',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周二至周日：07:30-10:30（法定假日放假）'
}, 
 {
    province: '辽宁',
    city: '鞍山',
    area: '铁东区',
    address: '辽宁省鞍山市立山区园林大道499-1号',
    name: '鞍山金普医院',
    word: 'A',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：7:30-10:00（法定假日放假）'
}, {
    province: '内蒙古',
    city: '呼和浩特',
    area: '赛罕区',
    address: '内蒙古自治区呼和浩特赛罕区敕勒川大街15号绿地中央广场蓝海A座商业2层',
    name: '爱康卓悦呼和浩特赛罕区敕勒川大街绿地蓝海大厦分院',
    word: 'H',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
},{
    province: '内蒙古',
    city: '包头',
    area: '九原区',
    address: '内蒙古自治区包头市九原区建设路与建华路交叉口东南角复正大厦华诚中心1层A103底店',
    name: '包头文治医院有限公司博鳌门诊部分公司',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周日：8:00-12:00（法定假日放假）'
}, {
    province: '内蒙古',
    city: '鄂尔多斯',
    area: '东胜区',
    address: '内蒙古东胜区吉劳庆北路37号',
    name: '鄂尔多斯华健医院',
    word: 'E',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, {
    province: '内蒙古',
    city: '赤峰市',
    area: '松山区',
    address: '内蒙古自治区赤峰市松山区鸭子河西路恒茂大厦(北门)四层',
    name: '赤峰新华卓越门诊部',
    word: 'C',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, {
    province: '宁夏',
    city: '银川',
    area: '金凤区',
    address: '银川市金凤区北京中路大世界商务广场E座5层',
    name: '爱康卓悦银川北京路大世界分院',
    word: 'Y',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
},{
    province: '宁夏',
    city: '银川',
    area: '金凤区',
    address: '北京路大世界商务广场E座5层（雪绒巷入口）',
    name: '爱康国宾银川北京路大世界分院',
    word: 'Y',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '山东',
    city: '青岛',
    area: '市北区',
    address: '青岛市市北区敦化路138号西王大厦西侧门4层',
    name: '爱康国宾青岛市北CBD西王大厦分院',
    word: 'Q',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '山东',
    city: '青岛',
    area: '市北区',
    address: '青岛市市北区敦化路138号301户',
    name: '爱康国宾青岛市北CBD西王大厦分院VIP部',
    word: 'Q',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '山东',
    city: '烟台',
    area: '开发区',
    address: '烟台市开发区长江路97号国家羽毛球训练基地（东门）',
    name: '爱康国宾烟台开发区长江路分院',
    word: 'Y',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周四至周二：08：00-10:30（法定假日放假）'
}, {
    province: '山东',
    city: '烟台',
    area: '开发区',
    address: '山东省烟台市开发区长江路97号国家羽毛球训练基地',
    name: '爱康国宾烟台开发区长江路分院VIP部',
    word: 'Y',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周四至周二：08：00-10:30（法定假日放假）'
}, {
    province: '山东',
    city: '烟台',
    area: '莱山区',
    address: '烟台市莱山区凤凰大街飞龙中润大厦3A层',
    name: '爱康国宾烟台莱山区凤凰大街中润大厦分院VIP部',
    word: 'Y',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '山东',
    city: '烟台',
    area: '莱山区',
    address: '烟台市莱山区港城东大街588号第三城国际大厦副楼1-3层',
    name: '爱康国宾烟台莱山区港城东大街分院',
    word: 'Y',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '放假时间：1月25日-2月9日'
}, {
    province: '山东',
    city: '烟台',
    area: '芝罘区',
    address: '烟台市芝罘区解放路156号世茂广场三楼',
    name: '爱康国宾烟台芝罘（福）区世茂分院',
    word: 'Y',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '放假时间：1月25日-2月9日'
}, {
    province: '山东',
    city: '淄博',
    area: '张店区',
    address: '淄博市张店区和平路17号蓝星体检中心',
    name: '淄博张店蓝星体检',
    word: 'Z',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：7:30-10:00（法定假日放假）'
},  {
    province: '山东',
    city: '济宁',
    area: '任城区',
    address: '山东省济宁市任城区洸河路62号',
    name: '济宁海关健康体检',
    word: 'J',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, {
    province: '山东',
    city: '东营',
    area: '东营区',
    address: '山东省东营市东营区东四路45号蓝色港湾2栋',
    name: '东营康之惠健康体检',
    word: 'D',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, {
    province: '山东',
    city: '日照市',
    area: '',
    address: '日照银川路6号',
    name: '日照白求恩医院',
    word: 'R',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周日：07:30-10:30（法定假日放假）'
},{
    province: '山东',
    city: '济南',
    area: '历下区',
    address: '山东省济南市历下区奥体西路2666号中国铁建·国际城BC座间裙房三层303、304、305、306号',
    name: '爱康国宾济南奥体西路中国铁建国际城分院',
    word: 'J',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '山东',
    city: '济南',
    area: '市中区',
    address: '济南市市中区纬二路51号山东商会大厦6层',
    name: '爱康卓悦济南纬二路山东商会大厦分院',
    word: 'J',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '山东',
    city: '临沂',
    area: '兰山区',
    address: '临沂市考棚街20-7',
    name: '临沂兰山区人民医院体检中心',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：7:30-9:30（法定假日放假）'
}, {
    province: '山东',
    city: '威海',
    area: '环翠区',
    address: '威海市环翠区海滨北路附36号府前商厦',
    name: '爱康国宾威海滨海分院',
    word: 'W',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '山东',
    city: '潍坊',
    area: '高新区',
    address: '潍坊市高新区卧龙东街与东方路交汇处',
    name: '爱康国宾潍坊东方路分院',
    word: 'W',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周四至周二：08：00-10:30（法定假日放假）'
}, {
    province: '山东',
    city: '潍坊',
    area: '奎文区',
    address: '潍坊市奎文区民生东街66号（原凯远大厦）',
    name: '爱康国宾潍坊新华路分院',
    word: 'W',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '山东',
    city: '滨州',
    area: '高新技术开发区',
    address: '滨州高新技术开发区新五路558号',
    name: '滨州欣悦康复医院',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, {
    province: '山西',
    city: '太原',
    area: '杏花岭区',
    address: '山西省太原市杏花岭区新建路111号佳艺特综合楼101室',
    name: '爱康卓悦太原新建北路分院',
    word: 'T',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '山西',
    city: '大同',
    area: '平城区',
    address: '大同市魏都大道东侧云顶雅园D座',
    name: '山西和谐健康体检中心大同分店',
    word: 'D',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：7:30-10:00（法定假日放假）'
}, {
    province: '山西',
    city: '长治',
    area: '潞州区',
    address: '山西省长治市太行东街272号（和济医院正对面）',
    name: '山西和谐健康体检中心长治分店',
    word: 'C',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周日：7:30-12:00（法定假日放假）'
}, {
    province: '山西',
    city: '临汾',
    area: '尧都区',
    address: '临汾市汾河一路1号（鼓楼北街北孝十字路口中西北角）',
    name: '山西和谐健康体检中心临汾分店',
    word: 'L',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周日：7:30-12:00（法定假日放假）'
}, {
    province: '陕西',
    city: '西安',
    area: '雁塔区',
    address: '西安市雁塔区慈恩西路南段曲江六号东门1-3层',
    name: '爱康国宾西安曲江分院',
    word: 'X',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '陕西',
    city: '西安',
    area: '未央区',
    address: '陕西省西安市未央区未央路与凤城八路十字东南角正尚国际4层',
    name: '爱康卓悦西安行政中心正尚国际分院',
    word: 'X',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '陕西',
    city: '西安',
    area: '莲湖区',
    address: '西安市莲湖区二环南路西段202号九座花园',
    name: '爱康卓悦西安南二环九座花园分院',
    word: 'X',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '陕西',
    city: '宝鸡',
    area: '渭滨区',
    address: '陕西省宝鸡市渭滨区公园路7号建工大厦401室、1207室',
    name: '宝鸡新华健康体检中心',
    word: 'B',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周六：7:50—12:00（法定假日放假）'
}, {
    province: '陕西',
    city: '咸阳',
    area: '秦都区',
    address: '咸阳市渭阳西路1号财苑大厦3-4层（体育场什字西北角）',
    name: '普惠咸阳体检中心',
    word: 'X',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周六：8:00-12:00（法定假日放假）'
}, {
    province: '陕西',
    city: '榆林',
    area: '',
    address: '榆阳区兴榆路火车站向南600米',
    name: '榆林泰福健康体检',
    word: 'Y',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, {
    province: '上海',
    city: '上海',
    area: '长宁区',
    address: '上海长宁区定西路1018号3层',
    name: '爱康国宾上海中山公园南延安西路分院',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
},  {
    province: '上海',
    city: '上海',
    area: '静安区',
    address: '上海市静安区康定路1437号（鑫康苑）2层',
    name: '爱康国宾上海曹家渡一品分院',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '上海',
    city: '上海',
    area: '浦东新区',
    address: '上海市浦东新区张杨路560号（中融恒瑞大厦）6楼西区',
    name: '爱康国宾上海浦东八佰伴分院',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '上海',
    city: '上海',
    area: '浦东新区',
    address: '上海市张杨路560号中融恒瑞国际大厦6楼西区（南泉北路张杨路路口）',
    name: '爱康国宾上海浦东八佰伴分院VIP部',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '上海',
    city: '上海',
    area: '黄浦区',
    address: '上海市黄浦区江西南路29号工商联大厦2层',
    name: '爱康国宾上海外滩延安东路分院',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '上海',
    city: '上海',
    area: '黄浦区',
    address: '上海市黄浦区江西南路29号2层',
    name: '爱康国宾上海外滩延安东路分院VIP部',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '上海',
    city: '上海',
    area: '黄浦区',
    address: '上海市黄浦区西藏南路770号（安基大厦）裙楼',
    name: '爱康国宾上海西藏南路老西门分院',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '上海',
    city: '上海',
    area: '黄浦区',
    address: '上海市黄浦区西 藏南路770号2层（3层一般是5层人数较多或者有团检时开放）',
    name: '爱康国宾上海西藏南路老西门分院VIP部',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '上海',
    city: '上海',
    area: '杨浦区',
    address: '上海市杨浦区国宾路36号万达广场B座5层',
    name: '爱康国宾上海五角场万达广场分院',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '上海',
    city: '上海',
    area: '杨浦区',
    address: '上海市杨浦区国宾路36号万达国际广场6楼',
    name: '爱康国宾上海五角场万达广场分院VIP部',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '上海',
    city: '上海',
    area: '浦东新区',
    address: '上海市浦东新区滨江大道999号高维大厦1-3楼',
    name: '爱康卓悦上海陆家嘴分院',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '上海',
    city: '上海',
    area: '普陀区',
    address: '上海市普陀区真光路1288号百联中环购物广场4层',
    name: '爱康国宾上海中环一品分院',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '上海',
    city: '上海',
    area: '普陀区',
    address: '上海市普陀区真光路1288号百联中环购物广场4层',
    name: '爱康国宾上海中环一品分院VIP部',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '四川',
    city: '成都',
    area: '高新区',
    address: '成都市高新区吉泰三路8号新希望国际C座3楼',
    name: '爱康国宾成都城南分院',
    word: 'C',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
}, {
    province: '四川',
    city: '成都',
    area: '高新区',
    address: '成都市高新区吉泰三路8号新希望国际大厦C座3楼。（高新区天府大道中段天府三街新希望国际C座3楼从11或12号电梯上）',
    name: '爱康国宾成都城南分院VIP部',
    word: 'C',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
}, {
    province: '四川',
    city: '成都',
    area: '高新区',
    address: '成都市高新区天韵路高新国际广场D座3层',
    name: '爱康国宾成都高新分院',
    word: 'C',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
},  {
    province: '四川',
    city: '成都',
    area: '锦江区',
    address: '成都市锦江区人民南路一段新光华街7号航天科技大厦5层',
    name: '爱康国宾成都红照壁航天科技分院',
    word: 'C',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周日至周五：08：00-10:30（法定假日放假）'
}, {
    province: '四川',
    city: '成都',
    area: '锦江区',
    address: '四川省成都市锦江区人民南路一段新光华街7号航天科技大厦5层',
    name: '爱康国宾成都红照壁航天科技分院VIP部',
    word: 'C',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周日至周五：08：00-10:30（法定假日放假）'
}, {
    province: '四川',
    city: '成都',
    area: '龙泉驿区',
    address: '成都市龙泉驿区大面街道金桉路88号百悦国际中心8-9楼',
    name: '爱康国宾成都龙泉百悦国际中心分院',
    word: 'C',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
}, {
    province: '四川',
    city: '成都',
    area: '金牛区',
    address: '成都市金牛区一品天下大街399号1栋5层1号',
    name: '爱康国宾成都茶店子居然之家分院',
    word: 'C',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周日至周五：08：00-10:30（法定假日放假）'
}, {
    province: '四川',
    city: '成都',
    area: '金牛区',
    address: '成都市金牛区一品天下街399号1栋5层1号',
    name: '爱康国宾成都茶店子居然之家分院VIP部',
    word: 'C',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周日至周五：08：00-10:30（法定假日放假）'
},  {
    province: '四川',
    city: '成都',
    area: '青羊区',
    address: '成都市青羊区青龙大街18号罗马国际大厦4楼',
    name: '爱康国宾成都骡马市分院',
    word: 'C',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周日至周五：08：00-10:30（法定假日放假）'
}, {
    province: '四川',
    city: '成都',
    area: '锦江区',
    address: '青羊区青龙街18号罗马国际广场4层(亚非牙科楼上)',
    name: '爱康国宾成都骡马市分院VIP部',
    word: 'C',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周日至周五：08：00-10:30（法定假日放假）'
}, {
    province: '四川',
    city: '成都',
    area: '武侯区',
    address: '成都市武侯区二环路西一段置信路1号置信逸都城5层',
    name: '爱康国宾成都外双楠分院',
    word: 'C',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
}, {
    province: '四川',
    city: '绵阳',
    area: '高新区',
    address: '绵阳高新区火炬北路附21号（交警四大队对面）',
    name: '爱康国宾绵阳高新火炬广场分院',
    word: 'M',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
}, {
    province: '四川',
    city: '绵阳',
    area: '高新区',
    address: '绵阳市高新区火炬北路附21号三汇金座4楼(交警四大队正对面)',
    name: '爱康国宾绵阳高新火炬广场分院VIP部',
    word: 'M',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
}, {
    province: '四川',
    city: '宜宾',
    area: '翠屏区',
    address: '四川省宜宾市叙州区赵场街道叙州大道普和东路16号体检管理中心',
    name: '宜宾市第一人民医院体检中心',
    word: 'Y',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-11:30（法定假日放假）'
},{
    province: '四川',
    city: '泸州',
    area: '江阳区',
    address: '泸州市江阳区酒谷大道二段',
    name: '泸州市人民医院体检中心(沙茜院区)',
    word: 'L',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-11:30（法定假日放假）'
},  {
    province: '天津',
    city: '天津',
    area: '河西区',
    address: '天津市河西区友谊北路51号合众大厦C座4层',
    name: '爱康卓悦天津友谊北路合众大厦分院',
    word: 'T',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '天津',
    city: '天津',
    area: '经济开发区',
    address: '天津经济开发区第二大街45号泰达MSD-F区F5-101/201/301单元',
    name: '爱康卓悦天津滨海新区泰达MSD分院',
    word: 'T',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
},  {
    province: '天津',
    city: '天津',
    area: '河西区',
    address: '天津市河西区友谊北路51号合众大厦C座4层',
    name: '爱康国宾天津友谊北路合众大厦分院',
    word: 'T',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '天津',
    city: '天津',
    area: '和平区',
    address: '天津市和平区南京路209号吉利大厦9层',
    name: '爱康国宾天津南京路吉利大厦分院',
    word: 'T',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '天津',
    city: '天津',
    area: '和平区',
    address: '天津市和平区南京路209号吉利大厦9层',
    name: '爱康国宾天津南京路吉利大厦分院VIP部',
    word: 'T',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '天津',
    city: '天津',
    area: '南开区',
    address: '天津市南开区南马路与南门外大街交口中粮广场6层',
    name: '爱康国宾天津南马路悦府广场分院',
    word: 'T',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '天津',
    city: '天津',
    area: '南开区',
    address: ' 天津市南开区南马路与南开二马路交口中粮广场1号楼7层',
    name: '爱康国宾天津南马路悦府广场分院VIP部',
    word: 'T',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '浙江',
    city: '杭州',
    area: '滨江区',
    address: '杭州市滨江区江南大道588号恒鑫大厦裙楼2层',
    name: '爱康国宾杭州滨江江南大道分院',
    word: 'H',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '浙江',
    city: '杭州',
    area: '萧山区',
    address: '杭州市萧山区钱江世纪城广孚联合国际中心裙楼2楼',
    name: '爱康国宾杭州钱江世纪城广孚中心分院',
    word: 'H',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '浙江',
    city: '杭州',
    area: '萧山区',
    address: '浙江省杭州市萧山区钱江世纪城广孚联合国际中心204室',
    name: '爱康国宾杭州钱江世纪城广孚中心分院VIP部',
    word: 'H',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
}, {
    province: '浙江',
    city: '杭州',
    area: '西湖区',
    address: '西湖区西溪栖悦城奥特莱斯2F',
    name: '爱康西溪天堂旗舰体检中心',
    word: 'H',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '浙江',
    city: '杭州',
    area: '滨江区',
    address: '杭州市滨江区江南大道588号恒鑫大厦裙楼2楼',
    name: '爱康国宾杭州滨江江南大道分院VIP部',
    word: 'H',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '浙江',
    city: '杭州',
    area: '西湖区',
    address: '西湖区西溪栖悦城奥特莱斯2F',
    name: '爱康西溪天堂旗舰体检中心VIP部',
    word: 'H',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '浙江',
    city: '杭州',
    area: '下城区',
    address: '杭州市下城区文晖路108号浙江出版物资大厦1-2楼',
    name: '爱康国宾杭州文晖分院',
    word: 'H',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '浙江',
    city: '杭州',
    area: '下城区',
    address: '杭州市下城区文晖路108号浙江物资出版大厦1层',
    name: '爱康国宾杭州文晖分院VIP部',
    word: 'H',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}
    
    , {
    province: '浙江',
    city: '杭州',
    area: '西湖区',
    address: '杭州市西湖区西溪栖悦城奥特莱斯2F',
    name: '爱康国宾杭州西溪天堂旗舰中心分院',
    word: 'H',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}
    , {
    province: '浙江',
    city: '杭州',
    area: '余杭区',
    address: '杭州市余杭区高教路与联创路交叉口奥克斯创智一号4幢',
    name: '爱康卓悦杭州未来科技城分院',
    word: 'H',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
}, {
    province: '浙江',
    city: '温州',
    area: '鹿城区',
    address: '温州市鹿城区黎明西路 1 号国贸大酒店 3F、5F',
    name: '爱康国宾温州国贸分院',
    word: 'W',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
}, {
    province: '浙江',
    city: '宁波',
    area: '海曙区',
    address: '宁波市海曙区中山西路2号恒隆中心西裙楼4层（蔡家巷6号上电梯）',
    name: '爱康国宾宁波鼓楼分院',
    word: 'N',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
}, {
    province: '浙江',
    city: '宁波',
    area: '海曙区',
    address: '宁穿路1316号7幢 ',
    name: '爱康卓悦宁波东部新城宏泰广场分院',
    word: 'N',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周二至周日：08：00-10:30（法定假日放假）'
}, {
    province: '浙江',
    city: '嘉兴',
    area: '',
    address: '嘉浙江省兴市中山西路527号财富广场19层',
    name: '嘉兴浙健体检中心门诊部',
    word: 'J',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周日：7:30-11:00（法定假日放假）'
},{
    province: '浙江',
    city: '金华市',
    area: '',
    address: '双溪西路439号金华市中医医院，中医药传承创新大楼8楼健康管理中心',
    name: '金华市中医医院',
    word: 'J',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
},  {
    province: '浙江',
    city: '绍兴',
    area: '',
    address: '浙江省绍兴市平江路575号',
    name: '绍兴文理学院附属医院',
    word: 'S',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：7:30-10:00（法定假日放假）'
}, {
    province: '浙江',
    city: '湖州',
    area: '吴兴区',
    address: '湖州美亚健康体检',
    name: '浙江省湖州市吴兴区二环西路1618号华悦商业广场7号楼',
    word: 'H',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, {
    province: '浙江',
    city: '台州',
    area: '高新区',
    address: '浙江省台州市高新区东海大道999号',
    name: '台州市中心医院',
    word: 'T',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：8:00-11:30（法定假日放假）'
},{
    province: '浙江',
    city: '丽水',
    area: '莲都区',
    address: '丽水市莲都区括苍路289号',
    name: '丽水中心医院',
    word: 'L',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
},{
    province: '浙江',
    city: '舟山市',
    area: '定海区',
    address: '浙江省舟山市定海区白泉镇瑞金路1号',
    name: '浙江定海医院(上海瑞金医院舟山分院)',
    word: 'Z',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, {
    province: '重庆',
    city: '重庆',
    area: '渝中区',
    address: '重庆市渝中区民生路235号海航保利国际中心4层',
    name: '爱康卓悦重庆解放碑分院',
    word: 'C',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-1.png',
    time: '营业时间：周日至周五：08：00-10:30（法定假日放假）'
}, {
    province: '重庆',
    city: '重庆',
    area: '渝北区',
    address: '重庆市渝北区洋河东路1号长安丽都揽胜国际广场2层',
    name: '爱康国宾重庆黄泥磅揽胜国际分院',
    word: 'C',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
}, {
    province: '重庆',
    city: '重庆',
    area: '江北区',
    address: '重庆市江北区福康路25号龙湖·源著天街6楼',
    name: '爱康国宾重庆龙湖源著欣康分院',
    word: 'C',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周日至周五：08：00-10:30（法定假日放假）'
},  {
    province: '重庆',
    city: '重庆',
    area: '渝北区',
    address: '重庆市渝北区洋河东路长安丽都揽胜国际广场2层',
    name: '爱康国宾重庆黄泥磅分院VIP部',
    word: 'C',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周一至周六：08：00-10:30（法定假日放假）'
}, {
    province: '重庆',
    city: '重庆',
    area: '沙坪坝区',
    address: '重庆市沙坪坝区沙南街60号',
    name: '爱康国宾重庆沙坪坝区分院',
    word: 'C',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/store-2.png',
    time: '营业时间：周一至周五：08：00-11:30（法定假日放假）'
}, {
    province: '云南',
    city: '昆明',
    area: '五华区',
    address: '昆明市五华区三市街柏联广场7层A-7',
    name: '云南健之佳体检中心',
    word: 'K',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周六：08：00-11:00（法定假日放假）'
}, {
    province: '云南',
    city: '昆明',
    area: '五华区',
    address: '云南省昆明市五华区护国路2号广业大厦25楼',
    name: '昆明仁康体检中心',
    word: 'K',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周六：07:50-12:00（周日、法定假日放假）'
}, {
    province: '云南',
    city: '大理',
    area: '经济开发区',
    address: '大理州大理经济开发区苍山东路86号',
    name: '大理民族医院',
    word: 'D',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-11:30（法定假日放假）'
}, {
    province: '云南',
    city: '曲靖市',
    area: '',
    address: '曲靖市曲沾大道凯天国际大酒店后面麒麟同惠医院',
    name: '曲靖麒麟同惠医院',
    word: 'Q',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, {
    province: '云南',
    city: '玉溪市',
    area: '',
    address: '玉溪市红塔区聂耳路二十一号',
    name: '玉溪市人民医院',
    word: 'Y',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}
    // ,{
    //     province:'甘肃',
    //     city:'兰州',
    //     area:'城关区',
    //     address:'甘肃省兰州市城关区酒泉路2号甘肃省邮政信息大厦3楼',
    //     name:'兰州大学第一医院（二分部）',
    //     word:'L',
    //     url:'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    //     time:'放假时间：1月24日-2月13日'
    // }
    , {
    province: '甘肃',
    city: '兰州',
    area: '城关区',
    address: '甘肃省城关区天水南路248号',
    name: '兰州大学第一医院一分部',
    word: 'L',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：7:30-10:30（法定假日放假）'
}, {
    province: '新疆',
    city: '乌鲁木齐',
    area: '新市区',
    address: '乌鲁木齐市新市区河南东路806号',
    name: '乌鲁木齐市第一人民医院分院',
    word: 'W',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：9:50-14：00（法定假日放假）'
}, {
    province: '广西',
    city: '南宁',
    area: '兴宁区',
    address: '兴宁区民主路20号职工广场',
    name: '南宁市第一人民医院健康体检中心',
    word: 'N',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周六：8:00-12:00（法定假日放假）'
}, {
    province: '广西',
    city: '桂林市',
    area: '',
    address: '广西壮族自治区桂林市新桥园路一号',
    name: '中国人民解放军联勤保障部队第九二四医院',
    word: 'G',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, {
    province: '广西',
    city: '钦州市',
    area: '',
    address: '广西省钦州市文峰南路219号',
    name: '钦州市第二人民医院',
    word: 'Q',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, {
    province: '广西',
    city: '柳州市',
    area: '',
    address: '广西壮族自治区柳州市文昌路20号五星百货乐和城',
    name: '柳州威尔康综合门诊有限公司',
    word: 'L',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周六：07:30-10:30（法定假日放假）'
}, {
    province: '黑龙江',
    city: '哈尔滨',
    area: '南岗区',
    address: '黑龙江省哈尔滨市南岗区教化街2号',
    name: '哈尔滨工业大学医院',
    word: 'H',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：7:30-10:00（法定假日放假）'
}, {
    province: '黑龙江',
    city: '大庆',
    area: '龙凤区',
    address: '大庆市龙凤区龙腾路东城领秀A区H座商服',
    name: '大庆北大',
    word: 'D',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, {
    province: '黑龙江',
    city: '牡丹江',
    area: '',
    address: '牡丹江市西三条路七星街307号',
    name: '牡丹江市北方医院',
    word: 'M',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}, {
    province: '青海',
    city: '西宁',
    area: '城东区',
    address: '西宁市新宁路2号',
    name: '西宁康福中西医结合医院',
    word: 'X',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周六：7:30-11:30（法定假日放假）'
}, {
    province: '西藏',
    city: '拉萨市',
    area: '城关区',
    address: '西藏自治区省拉萨市城关区仙足岛生态路6号',
    name: '西藏阜康医疗股份有限公司健康体检中心',
    word: 'X',
    url: 'https://mgb.oss-cn-shenzhen.aliyuncs.com/image/p2.png',
    time: '营业时间：周一至周五：07:30-10:30（法定假日放假）'
}
]


export default store